import InlineDialog from '@atlaskit/inline-dialog';
import type { InlineDialogProps } from '@atlaskit/inline-dialog/types';
import { withChoreographedToggle } from '@atlassian/jira-choreographer-services/src/main.tsx';

export const ChoreographerInlineDialog = withChoreographedToggle<InlineDialogProps>(
	InlineDialog,
	'isOpen',
	'content',
);
